import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { StudentViewModel } from "src/app/models/student-view-model";
import { MailService } from "src/app/services/mail.service";
import { StudentService } from "src/app/services/student.service";

@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.css"],
})
export class PopupComponent implements OnInit {
  @Input() isOpenPopup: boolean = false;
  @Input() selectedStudent: StudentViewModel;
  @Output() eventPopup = new EventEmitter<boolean>();
  @Output() actionStudent = new EventEmitter<String>();
  @Output() changeStudent = new EventEmitter<StudentViewModel>();
  @Input() typePopup: string;
  isLoading: boolean = false;
  public isOtherValue: boolean = false;
  private rejectnote: string = "";
  file_data: any = "";
  @ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
  files: any[] = [];

  constructor(
    private mailService: MailService,
    private studentService: StudentService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void { }

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }
  prepareFilesList(files: Array<any>) {
    this.files = [];
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
      console.log(item);
      console.log("finfo", item.name, item.size, item.type);
    }

    this.fileDropEl.nativeElement.value = "";
    //this.uploadFilesSimulator(0);
  }
  deleteAllFile() {
    this.files = [];
  }

  formatFullName(texto: string) {
    var finalText = texto.split(" ");
    if (finalText.length > 2) {
      return finalText[0] + " " + finalText[2];
    } else {
      return finalText[0] + " " + finalText[1];
    }
  }
  closePopup() {
    this.isOpenPopup = false;
    this.isOtherValue = false;
    this.typePopup = "";
    this.eventPopup.emit(this.isOpenPopup);
    this.actionStudent.emit(this.typePopup);
    this.changeStudent.emit(this.selectedStudent);
    this.deleteAllFile();
  }
  //   sendConfirmationEmail(): void {
  //     const formData: FormData = new FormData();
  //     formData.append(
  //       "fullName",
  //       this.formatFullName(
  //         this.selectedStudent.name + " " + this.selectedStudent.lastname
  //       )
  //     );
  //     formData.append("campusName", this.selectedStudent.campus);
  //     formData.append("email", this.selectedStudent.email);
  //     formData.append("file", this.files[0]);
  //     this.isLoading = true;
  //     const obj = {
  //       stateChange: 8,
  //       log: "Estudiante matriculado el " + new Date(),
  //     };
  //     this.selectedStudent.stateChange = 8;
  // 
  //     const id = this.selectedStudent.id;
  //     this.studentService.editSavePartial(id, obj).then(() => {
  //       this.mailService.onSendService(formData).subscribe(
  //         (res) => {
  //           console.log("mensaje desde mailphp", res);
  //           if (res.message == "Message sent!") {
  //             this.isLoading = false;
  //             this.closePopup();
  //           }
  //         },
  //         (err) => {
  //           console.log(err);
  //           this.closePopup();
  //         }
  //       );
  //     });
  //   }

  ///codigo nuevo y optimizado

  async sendConfirmationEmail(): Promise<void> {
    try {
      this.isLoading = true;
      const formData = this.constructFormData();

      const obj = {
        stateChange: 8,
        log: "Estudiante matriculado el " + new Date(),
      };

      this.selectedStudent.stateChange = 8;
      const id = this.selectedStudent.id;

      this.onChangeState(id, obj)
      const mailSent = await this.sendEmail(formData);

      if (mailSent === "Message sent!") {
        //no es necesaria la validacion del correo  
        // this.isLoading = false;
        // this.closePopup();
      }
    } catch (error) {
      console.error("Error:", error);
      this.closePopup();
      this.isLoading = false;
    }
  }

  onChangeState(id, obj) {
    this.ngZone.runOutsideAngular(() => {
      this.studentService.editSavePartial(id, obj).then(() => {
        this.ngZone.run(() => {
          this.isLoading = false;
          this.closePopup();
        })
      }).catch(error => {
        this.ngZone.run(() => {
          console.error("Error:", error);
          this.closePopup();
          this.isLoading = false;
        })

      })
    })

  }

  constructFormData(): FormData {
    const formData: FormData = new FormData();
    formData.append("fullName", this.formatFullName(`${this.selectedStudent.name} ${this.selectedStudent.lastname}`));
    formData.append("campusName", this.selectedStudent.campus);
    formData.append("email", this.selectedStudent.email);
    formData.append("file", this.files[0]); // Assuming files are already initialized
    return formData;
  }

  async sendEmail(formData: FormData): Promise<string> {
    try {
      const res = await this.mailService.onSendServiceConfirmation(formData).toPromise();
      return res.message || ''; // Assuming 'message' contains the status of the sent email
    } catch (error) {
      console.error("Error sending email:", error);
      throw new Error("Error sending the email.");
    }
  }

  rejectStudent() {
    if (
      this.selectedStudent.stateChange > 0 &&
      this.selectedStudent.stateChange < 3
    ) {
      const obj = { stateChange: 3, rejectnote: this.rejectnote };
      this.selectedStudent.stateChange = 3;
      this.selectedStudent.rejectnote = this.rejectnote;
      const id = this.selectedStudent.id;
      this.isLoading = true;
      this.studentService.editSavePartial(id, obj).then(() => {
        this.closePopup();
        this.isLoading = false;
      });
    } else {
      console.log("no lo puedes rechazar");
    }
  }
  onChangeReject($event) {
    if ($event === "Otro") {
      this.isOtherValue = true;
    } else {
      this.isOtherValue = false;
    }
    this.rejectnote = $event;
  }
}
